import { render } from "./AddFarm.vue?vue&type=template&id=fa6e5228"
import script from "./AddFarm.vue?vue&type=script&lang=js"
export * from "./AddFarm.vue?vue&type=script&lang=js"

import "./AddFarm.vue?vue&type=style&index=0&id=fa6e5228&lang=scss"
import "./AddFarm.vue?vue&type=style&index=1&id=fa6e5228&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__